<template>
  <div class="box10-page">
    <div class="fcp-title">专业科学的服务保障<br/>只为让你一技傍身</div>
    <ul>
      <li 
        v-for="(item, index) in list" 
        :key="index"
        :style="{backgroundImage: `url(${require('../../../assets/coursePage/fcp/box10/card-bg-0' + (index + 1) + '.png')})`}"
      >
        <h2>{{ item.title }}</h2>
        <p v-for="(v1, i1) in item.info" :key="i1">{{ v1 }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        list:[
          {
            title: '服务保障',
            info: [
              '全程督学',
              '专属交流学习群',
              '录播课+直播答疑',
              '陪伴式学习'
            ]
          },
          {
            title: '学习资料',
            info: [
              '配套教辅课件',
              '考前模拟题'
            ]
          },
          {
            title: '特色服务',
            info: [
              '考试券',
              '考试未通过半年内课程反复可看',
              '半年内一次重考机会'
            ]
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
.box10-page{
  height: 1420px;
  padding: 80px 0 0;
  background-image: url(../../../assets/coursePage/fcp/box10/box10-bg.png);
  background-size: cover;
  box-sizing: border-box;
  ul{
    margin-top: 48px;
    li{
      width: 746px;
      padding: 74px 0 0 195px;
      background-size: 100% 100%;
      box-sizing: border-box;
      h2{
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1F375F;
        line-height: 52px;
        margin-bottom: 16px;
      }
      p{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1F375F;
        line-height: 56px;
      }
    }
    li:nth-of-type(1){
      height: 464px;
      margin-top: -10px;
    }
    li:nth-of-type(2){
      height: 352px;
      margin-top: -35px;
    }
    li:nth-of-type(3){
      height: 408px;
      margin-top: -35px;
    }
  }
}
</style>